import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc.js'
import timezone from 'dayjs/plugin/timezone.js'
import isSameOrAfter from "dayjs/plugin/isSameOrAfter.js";
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(isSameOrAfter);
import generateTour from './generateTour.js';
import generateOvertime from './generateOvertime.js';
import generateMeal from './generateMeal.js';
import generateAssignments from  './generateAssignments.js';
import generateOffTime from './generateOffTime.js';
import generateOffTimeRequest from './generateOffTimeRequests.js';
import generateAssignment from './generateAssignment.js';
import _ from 'lodash';

/**
 * Returns an array of items that have been formatted into the correct order to be displayed in the one to two day schedule.
 * Items are made up of tours, daysOff, overtimes, and meals.
 * @param {*} schedule
 */
const generateItems = (schedule, scheduleFormat, startDate) => {
  if (schedule) {
    const items = {};
    let timeOffset;
    for (let resource of schedule) {
      const { rId } = resource;
      items[rId] = [];
      if (resource.dayTypes) {
        // eslint-disable-next-line no-unused-vars        
        for (let [rdtId, dayType] of Object.entries(resource.dayTypes)) {
          if (dayType.tour) {
            const { startTime, duration, remainDuration } = dayType.tour;

            // Corrects for the amount of time a day overlaps another day
            let actualDuration;
            if (parseFloat(remainDuration) > 0.0) {
              actualDuration = parseFloat(duration) - parseFloat(remainDuration);
            } else actualDuration = parseFloat(duration);
            // time formatting
           let tourStartTime = dayjs(dayjs.unix(startTime).utc().format("YYYY-MM-DD HH:mm:ss"));
            
            // reverse strange DST behavior from  pushes clock back an hour on Spring DST Saturday - AAdekoya (2/17/2021)
            // Note: seems to only apply this on startDate of schedule and only if it is the saturday before spring forward / fall back day
            let springForwardDay;
            let fallBackwardDay;
            timeOffset =0;//dayjs().utcOffset()*-1; 
            //tourStartTime = tourStartTime.add(timeOffset, 'minute');
            let tourEndTime = tourStartTime.add(actualDuration, 'hour');

            if (startDate && startDate.length >10) {
              if (dayjs(startDate.substring(0,10)).isAfter(tourStartTime)){
                tourStartTime = dayjs(startDate.substring(0,10));
              } 
            }

            // generate timeSummary string (i.e. '7a-4:30p')
            let start = dayjs(tourStartTime.add(timeOffset*-1,'minute')).format('h:mma').slice(0, -1);
            if (start.split(':')[1].slice(0,2) === '00') {
              start = dayjs(tourStartTime.add(timeOffset*-1,'minute')).format('ha').slice(0, -1);
            }
            let end =  dayjs(tourEndTime.add(timeOffset*-1,'minute')).format('h:mma').slice(0, -1);
            if (end.split(':')[1].slice(0,2) === '00') {
              end = dayjs(tourEndTime.add(timeOffset*-1,'minute')).format('ha').slice(0, -1);
            }
            
            const timeSummary = start + '-' + end;

            const hasMeal = dayType.tour.meal &&  dayjs(dayjs.unix(dayType.tour.meal.mealTime).utc().format("YYYY-MM-DD HH:mm:ss")).add(timeOffset, 'minute').isSameOrAfter (tourStartTime) || false
            const hasOvertime =  dayType.tour.overTime &&  dayjs(dayjs.unix(dayType.tour.overTime.startTime).utc().format("YYYY-MM-DD HH:mm:ss")).add(timeOffset, 'minute').isSameOrAfter(tourStartTime) || false
            
              // tours with no meal and no overtime
            if (resource.rId && resource.name && !hasMeal && !hasOvertime ) {
              const adjustedTour = generateTour('no-meal-no-overtime', null, resource, dayType, tourStartTime, tourEndTime, timeSummary);
              items[rId].push(adjustedTour);
            }

            // tours with overtime but no meal
            if (resource.rId && resource.name && hasOvertime && !hasMeal) {
              const overtimeStartTime = dayjs(dayjs.unix(dayType.tour.overTime.startTime).utc().format("YYYY-MM-DD HH:mm:ss"));
              const overtimeEndTime =dayjs(dayjs.unix(dayType.tour.overTime.endTime).utc().format("YYYY-MM-DD HH:mm:ss"));
              const adjustedTour = generateTour('overtime-no-meal', null, resource, dayType, tourStartTime, tourEndTime, timeSummary, null, null,overtimeStartTime, timeOffset);
              const overtime = generateOvertime('no-meal', resource, dayType,null,null, overtimeStartTime,overtimeEndTime);
              
              items[rId].push(adjustedTour);
              items[rId].push(overtime);
            }

            // tour has meal
            if (resource.rId && resource.name && hasMeal) {
              // time formatting
              let mealStartTime = dayjs(dayjs.unix(dayType.tour.meal.mealTime).utc().format("YYYY-MM-DD HH:mm:ss")).add(timeOffset, 'minute');
              let mealEndTime = dayjs(dayjs.unix(dayType.tour.meal.mealEndTime).utc().format("YYYY-MM-DD HH:mm:ss")).add(timeOffset, 'minute');
              if (springForwardDay) {
                mealStartTime = mealStartTime.add(1, 'hour');
                mealEndTime = mealEndTime.add(1, 'hour');
                tourEndTime = tourEndTime.add(1, 'hour');
              }

              /** figure out if you need to break-up the tour or not when generatinng the meal item */
              const preMealTourDuration = mealStartTime.diff(tourStartTime,'minute');
              const postMealTourDuration = tourEndTime.diff(mealEndTime,'minute');

                    // tours with no overtime
                if (!hasOvertime) {
                    // meal is at the beginning of the tour ==> just adjust tour startTime
                    if (preMealTourDuration <= 5) {
                      const adjustedTour = generateTour('meal-no-overtime', 'meal-first', resource, dayType, tourStartTime, tourEndTime, timeSummary, null, mealEndTime);
                      items[rId].push(adjustedTour);

                      // tour begins before the meal does
                    } else if (preMealTourDuration> 5) {
                      // meal is at the end of the tour ==> just adjust tour endTime
                      if (postMealTourDuration < 5) {
                        const adjustedTour = generateTour('meal-no-overtime', 'meal-last', resource, dayType, tourStartTime, tourEndTime, timeSummary, mealStartTime);
                        items[rId].push(adjustedTour);
                      } else { // meal is in the middle of the tour => split tour into two
                        const adjustedTour = generateTour('meal-no-overtime', 'meal-middle', resource, dayType, tourStartTime, tourEndTime, timeSummary, mealStartTime, mealEndTime);
                        items[rId].push(adjustedTour.preMeal);
                        items[rId].push(adjustedTour.postMeal);
                      }
                    }

                }  // end no overtime

                // tours with overtime
                if (hasOvertime) {
                  let overtimeStartTime = dayjs(dayjs.unix(dayType.tour.overTime.startTime).utc().format("YYYY-MM-DD HH:mm:ss")).add(timeOffset, 'minute');
                  let overtimeEndTime = dayjs(dayjs.unix(dayType.tour.overTime.endTime).utc().format("YYYY-MM-DD HH:mm:ss")).add(timeOffset, 'minute');
                  if (springForwardDay) {
                    overtimeStartTime = overtimeStartTime.add(1, 'hour');
                    overtimeEndTime = overtimeEndTime.add(1, 'hour');
                  }
                  const mealDurationBeforeOvertime = overtimeStartTime.diff(mealStartTime,'minute');
                  const overtimeDuration = overtimeEndTime.diff(overtimeStartTime,'minute');
                  const overtimeDurationBeforeMeal = mealStartTime.diff(overtimeStartTime,'minute');

                  // tours with meals starting before or at the same time as overtime
                  if (mealDurationBeforeOvertime >= 0  ) {

                    // meal is at the beginning of the tour ==> just adjust tour startTime
                    if (preMealTourDuration <= 5) {
                      const adjustedTour = generateTour('meal-before-overtime', 'meal-first', resource, dayType, tourStartTime, tourEndTime, timeSummary, null, mealEndTime, overtimeStartTime);
                      const overtime = generateOvertime('no-meal', resource, dayType, null, null, overtimeStartTime, overtimeEndTime);
                      items[rId].push(adjustedTour);
                      items[rId].push(overtime);

                    // tour begins before the meal does
                    } else if (preMealTourDuration > 5) {
                      // meal is at the end of the tour ==> just adjust tour endTime

                      // record time diff between mealStartTime and overtimeStartTime for later use
                      const diffBetwMealStartAndOT = dayjs(dayjs.unix(dayType.tour.overTime.startTime).utc().format("YYYY-MM-DD HH:mm:ss")).diff(mealStartTime,'minute');

                      // there is no tour duration (incl. overTime) after the meal ends
                      if (postMealTourDuration < 5) {
                        const adjustedTour = generateTour('meal-before-overtime', 'meal-last', resource, dayType, tourStartTime, tourEndTime, timeSummary, mealStartTime, null, overtimeStartTime);
                        // since meal is before or simultaneous with overtime and we also know that meal is last, we can safely insert the
                        // adjusted tour into array, there will be no OT rendering, so this tour is complete at this stage
                        items[rId].push(adjustedTour);

                      // meal and overtime start at roughly same time AND overtime is longer than meal
                    } else if (Math.abs(diffBetwMealStartAndOT) <= 5
                        && postMealTourDuration >= 5
                    ) {
                        // using meal-last here bc there is no reason to generate a post-meal item, overtime will be generated instead
                        const adjustedTour = generateTour('meal-before-overtime', 'meal-last', resource, dayType, tourStartTime, tourEndTime, timeSummary, mealStartTime, mealEndTime, overtimeStartTime, timeOffset);
                        const adjustedOvertime = generateOvertime('meal-first', resource, dayType, null, mealEndTime, overtimeStartTime, overtimeEndTime);  // 'meal-first
                        items[rId].push(adjustedTour);
                        items[rId].push(adjustedOvertime);
                    }
                    else { // meal is in the middle of the tour => split tour into two
                        const adjustedTour = generateTour('meal-before-overtime', 'meal-middle', resource, dayType, tourStartTime, tourEndTime, timeSummary, mealStartTime, mealEndTime, overtimeStartTime, timeOffset);
                        const overtime = generateOvertime('no-meal', resource, dayType, null, null, overtimeStartTime, overtimeEndTime);
                        items[rId].push(adjustedTour.preMeal);
                        items[rId].push(adjustedTour.postMeal);
                        items[rId].push(overtime);
                    }
                  }
                }

                      // tours with meal 'in the middle' of overtime (note, also covers if meal is very last thing rendered: then overtimeEndTime = mealEndTime)
                      if (overtimeDurationBeforeMeal >= 5 && overtimeDuration >= 65) {
                        const adjustedTour = generateTour('overtime-no-meal', null, resource, dayType, tourStartTime, tourEndTime, timeSummary, null, null, overtimeStartTime, timeOffset);
                        const adjustedOvertime = generateOvertime('meal-middle', resource, dayType, mealStartTime, mealEndTime, overtimeStartTime, overtimeEndTime);
                        items[rId].push(adjustedTour);
                        items[rId].push(adjustedOvertime.preMeal);
                        items[rId].push(adjustedOvertime.postMeal);
                      }


                }  // end tours with overtime


                 // generate meal
                 const meal = generateMeal(resource, dayType, mealStartTime, mealEndTime, scheduleFormat);
                 items[rId].push(meal);                 
            } // end tour has meal

              // generate assignments
              if (resource.rId && resource.name && dayType.tour.assignments) {                 
                const assignmentArray = generateAssignments(resource, dayType, null, timeOffset, scheduleFormat,tourStartTime);
                for (let assignment of assignmentArray) {
                  items[rId].push(assignment);
                }
              }
              
        } // end if (dayType.tour)

      if (dayType.dayOff) {
        const alreadyOff = items[rId].find(item => {
          return item.hasOwnProperty('dorId');
        });

        if (!alreadyOff ||
            alreadyOff.start_time.format('M/D/YYYY')
            !== dayjs.unix(dayType.dayOff.startTime).utc().format("M/D/YYY")) {
          const offTime = generateOffTime(resource, dayType);
          items[rId].push(offTime);
        }
      }

      if (dayType.dayOffRequest) {
        // Checking if the day off request goes over multple days.
        let dayAmount = dayjs.unix(dayType.dayOffRequest.endTime).utc()
        .diff(dayjs.unix(dayType.dayOffRequest.startTime).utc(), 'day');

        // Splitting days off that go over multiple days into day objects
        if (dayAmount > 1) {
          let clonedDayType = _.cloneDeep(dayType);
          for (let x = 0; x <= dayAmount; x++) {
              if (x !== 0) {
                clonedDayType.dayOffRequest.startTime = dayjs(dayjs.unix(clonedDayType.dayOffRequest.startTime).utc().format("YYYY-MM-DD HH:mm:ss")).add(1, 'day').unix();
                clonedDayType.dayOffRequest.dorId = clonedDayType.dayOffRequest.dorId.slice(0, -1) + x;
              } else clonedDayType.dayOffRequest.dorId += "-" + x;
              items[rId].push(generateOffTimeRequest(resource, clonedDayType));
          }
        // if the day off request only goes over one day.
        } else items[rId].push(generateOffTimeRequest(resource, dayType));
      }

      if (dayType.assignment) {
        items[rId].push(generateAssignment(resource, dayType, scheduleFormat));
      }

    } // end loop for (resource.dayTypes)


      }  // end if (resource.dayTypes)

    }  // end loop for (resource of schedule)

    
    const nestedItemrray = (Object.values(items));
    
    const flattenedArray = [].concat.apply([], nestedItemrray);

    flattenedArray.sort((a, b) => a.timelineDisplayOrder > b.timelineDisplayOrder ? 1 : -1);
    return flattenedArray;
  } else return [];
}

export default generateItems;
